const isBaseNameAvailable = () => {
  const currentURL = window.location.href;
  const baseName = ['marksandspencer', 'luxecollectivefashion', 'cocoonsleeping.com'];
  return baseName.some((name) => currentURL.includes(name));
};

export default isBaseNameAvailable;
